<script lang="ts">
import { computed } from 'vue';

import type { PhxsgTabsButtonDimensions, PhxsgTabsOrientation } from './tabs.types';

export interface PhxsgTabIndicatorProps {
  dimensions: PhxsgTabsButtonDimensions;
  orientation?: PhxsgTabsOrientation;
  thickness?: number;
}
</script>

<script setup lang="ts">
const { dimensions, orientation = 'horizontal' } = defineProps<PhxsgTabIndicatorProps>();

const indicatorStyle = computed(() => {
  if (orientation === 'vertical') {
    return {
      height: `${dimensions.height}px`,
      transform: `translate3d(${dimensions.left}px, ${dimensions.top}px, 0)`,
    };
  }

  return {
    width: `${dimensions.width}px`,
    transform: `translate3d(${dimensions.left}px, 0, 0)`,
  };
});
</script>

<template>
  <span class="phxsg-tabs__indicator" aria-hidden="true" :style="indicatorStyle"></span>
</template>
